import { useAppState } from 'hooks/useAppState';

export const useSession = () => {
  const { session } = useAppState();

  return session;
};
